import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FirebaseDataService} from './firebase-data.service';
import {GraphModeService} from './graph-mode.service';
import {ModeManagerService} from './mode-manager.service';
import {ModeDataService} from './mode-data.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [FirebaseDataService, GraphModeService, ModeManagerService, ModeDataService]
})
export class EditorStateModule {}
